import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import LogoIcon from './kizen-word-mark.svg?react';

const LOGO_HEIGHT = 24;

const StyledImg = styled.img`
  user-select: none;
  pointer-events: none;
  width: auto;
  height: ${LOGO_HEIGHT}px;
`;

const Logo = ({ customLogo, customName = 'Kizen' }) => {
  const { t } = useTranslation();
  const alt = t('{{name}} Logo', { name: customName });
  return (
    <StyledImg
      {...(customLogo ? { src: customLogo, alt } : { as: LogoIcon })}
      height={LOGO_HEIGHT}
      role="button"
      tabIndex={0}
      aria-label={alt}
      className="KizenLogo"
    />
  );
};

export default Logo;
